import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=022927b8&"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=ts&"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=ts&"
import style0 from "./verticalNavMenu.scss?vue&type=style&index=0&lang=scss&scale=true&"
import style1 from "./VerticalNavMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports